<template>
  <v-row class="maxheight mt-0" style="border-top: 1px solid #e3e3e3 !important; overflow-x: hidden;" no-gutters
    @mouseleave="hoveredItem = null">
    <v-col cols="auto" class="pa-0 firststep_column">
      <v-card v-for="item in topLevelRoutes"
        v-show="licenced(item) && featureEnabled(item) && authorized(item) && !isHidden(item)" :key="item.name"
        :node="item" class="firststep"
        :class="[isCurrentFlowout(item) ? 'flowout' : '', isActive(item) ? 'active' : '']" flat
        :to="{ name: item.name }" :ripple="false" @mouseenter="hoveredItem = item">
        <v-icon size="20" :color="highlightcolor(item)">{{ item.meta.icon }}</v-icon>
        <p :class="highlightcolor(item) + '--text'" class="mb-0 text-center">
          {{ item.meta.display ? $t(item.meta.display.key, { okey: item.meta.display.okey }) : item.meta.displayName }}
        </p>
      </v-card>
    </v-col>
    <v-col v-if="shownSubRoutes.length" class="pa-0 maxheight" @mouseenter="() => {
      if (!hoveredFlowsOut) {
        hoveredItem = null
      }
    }">
      <v-list v-if="shownSubRoutes && shownSubRoutes.length" dense class="py-0">
        <!-- list item bellow is a spacer dont remove -->
        <v-list-item class="spacerli2" />
        <RouteListItem v-for="item in shownSubRoutes" :key="item.name" :node="item" :class="setOldGuiCssClass(item)">
        </RouteListItem>
        <!-- list item bellow is a spacer dont remove -->
        <v-list-item class="spacerli" />
      </v-list>
    </v-col>
    <v-btn v-if="shownSubRoutes && shownSubRoutes.length" class="rounded-circle pa-0" color="primary" small
      style="position: absolute; bottom: 77px; right: 8px; min-width: 28px;">
      <v-icon @click="handletogglecolloapse(!lastShowPanelEmit)">
        {{ !lastShowPanelEmit ? 'mdi-chevron-right' : 'mdi-chevron-left' }}
      </v-icon>
    </v-btn>
  </v-row>
</template>


<script>
import RouteListItem from "@/components/SingleUse/ComponentOverrides/sidebar/RouteListItem_Base.vue";
import NavMixin from "@/helpers/Mixins/NavMixin.js";

export default {
  components: {
    RouteListItem,
  },
  mixins: [NavMixin],

  data() {
    return {
      menuTree: this.$router.options.routes,
      hoveredItem: null,
      lastShowPanelEmit: false,
    };
  },
  mounted() {
    this.emitShowChildPanel(!!this.shownSubRoutes.length);
  },

  methods: {
    isActive(item) {
      return this.currentTopLevelRoute?.name == item.name;
    },

    isHovered(item) {
      return this.hoveredItem && this.hoveredItem.name == item.name;
    },

    isCurrentFlowout(item) {
      if (this.hoveredFlowsOut && this.hoveredItem.name == item.name) {
        return true;
      }
      else if (!this.hoveredFlowsOut && this.currentTopLevelRoute && this.currentTopLevelRoute.name == item.name) {
        return true;
      }
      else {
        return false;
      }
    },

    highlightcolor(item) {
      if (this.isActive(item)) {
        return 'primary';
      }
      else if (this.isHovered(item)) {
        return 'tertiary';
      }
      else {
        return '';
      }
    },

    handletogglecolloapse(val) {
      if (this.hoveredFlowsOut) {
        this.hoveredItem = null
      }
      setTimeout(() => this.emitShowChildPanel(val), 50);
    },

    getShownChildren(node) {
      if (!node.children || !node.children.length) {
        return []
      }
      else {
        return node.children.filter(n => !n.meta || !n.meta.overrides || n.meta.overrides.sidebar !== false);
      }
    },

    emitShowChildPanel(val) {
      this.lastShowPanelEmit = val;
      this.$emit('showChildPanel', val);
    },

    authorized(node) {
      return this.checkUserAuthorizationForNode(node);
    },
    licenced(node) {
      return this.checkIfLicencedByKey(node.meta.licenceEnabled);
    },
    featureEnabled(node) {
      return this.checkIfFeatureEnabledByKey(node.meta.featureEnabled);
    },
    isHidden(node) {
      return node?.meta?.overrides?.sidebar === 'hidden';
    },

    setOldGuiCssClass(node) {

      if (process.env.NODE_ENV === 'production' && this.$store.state.GlobalSettings.IsSaasMode && node.component?.name?.includes("OldGuiFrame")) {
        return "hidden"
      } else if (process.env.NODE_ENV === 'development' && node.component?.name?.includes("OldGuiFrame")) {
        return "oldgui-menu"
      }
      return "";
    }
  },

  computed: {
    topLevelRoutes() {
      if (this.menuTree && this.menuTree.length) {
        return this.menuTree.filter(n => !n.meta || !n.meta.overrides || n.meta.overrides.sidebar !== false);
      }
      else {
        return [];
      }
    },

    currentTopLevelRoute() {
      if (this.$route && this.$route.matched && this.$route.matched[0]) {
        var topLevelParentRoute = this.topLevelRoutes.find(x => x.name == this.$route.matched[0].name);
        return topLevelParentRoute;
      }
      else {
        return null
      }
    },

    currentItem() {
      return this.hoveredItem ?? this.currentTopLevelRoute;
    },

    hoveredFlowsOut() {
      return (this.hoveredItem && this.getShownChildren(this.hoveredItem).length);
    },

    shownSubRoutes() {
      if (this.currentItem && this.getShownChildren(this.currentItem).length) {
        return this.getShownChildren(this.currentItem);
      }
      else if (this.currentTopLevelRoute && this.getShownChildren(this.currentTopLevelRoute).length) {
        return this.getShownChildren(this.currentTopLevelRoute)
      }
      else {
        return [];
      }
    },
  },

  watch: {
    shownSubRoutes: function () {
      this.emitShowChildPanel(!!this.shownSubRoutes.length);
    },
  },
};
</script>



<style lang="scss">
.firststep_column {
  background-color: #f9f9f9 !important;
  border-right: 1px solid #e3e3e3 !important;
}

.firststep {
  display: flex;
  flex-direction: column !important;
  align-items: center;
  justify-content: center;
  border-radius: 0px !important;
  width: 85px;
  height: 70px;
  background-color: transparent !important;
}

.firststep p {
  font-size: 11.6px !important;
  max-width: 80%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Menu optimization for small laptop screens with high dpi */
@media only screen and (max-height: 730px) {
  .firststep {
    width: 65px;
    height: 52px;
  }

  .firststep p {
    font-size: 10px !important;
  }

}

/* Menu optimization for large screens */
@media only screen and (min-height: 1090px) {
  .firststep {
    width: 95px;
    height: 80px;
  }

  .firststep p {
    font-size: 13px !important;
  }
}

.firststep.flowout {
  border-top: 1px solid #e3e3e3 !important;
  border-bottom: 1px solid #e3e3e3 !important;
  background-color: #f2f2f2 !important;
}

.firststep.active::before {
  content: "";
  color: var(--v-primary-darken2) !important;
  width: 5px;
  left: 0px;
  z-index: 11;
  opacity: 1 !important;
  border-radius: 1px;
}

.firststep.flowout::after {
  content: "";
  background-color: #f2f2f2 !important;
  width: 5px;
  height: 100%;
  right: -2px;
  top: 0;
  z-index: 11;
  opacity: 1 !important;
  border-radius: 0px;
  position: absolute;
}

.maxheight {
  max-height: 100%;
  overflow: overlay;
  /*border-top: 1px solid rgb(238, 238, 238);*/
}

@-moz-document url-prefix() {

  //Firefox does not support overlay overflow, and interprets it as none instead of auto.
  .maxheight {
    overflow: auto;
  }
}

.spacerli {
  min-height: 20px !important;
  max-height: 20px !important;
}

.spacerli2 {
  min-height: 8px !important;
  max-height: 8px !important;
}

.oldgui-menu {
  border: 5px solid purple;

}
</style>
